export default __webpack_public_path__ + "static/media/downLeftArrow.fd47bda0.png";